import { apolloClient } from '@/graphql/apollo'
import { GET_ALL_TAGS_QUERY, GET_UNTAGGED_QUERY, GET_ALL_TAGS_NO_PAGE_QUERY, GET_TAG_QUERY, CREATE_TAG_MUTATION, UPDATE_TAG_MUTATION, DELETE_TAG_MUTATION, RENAME_TAG_MUTATION } from '@/graphql/queries/tags'
import { normalize } from 'normalizr'
import _ from 'lodash'
import { tagSchema, tagsSchema } from '@/schema'

import { initStateMixin, gettersMixin, actionsMixin, mutationsMixin } from '@/mixins/crud/store'

const initState = () => {
  return initStateMixin()
}

// initial state
const state = initState()

// getters
const getters = {
  ...gettersMixin,
  all: (state) => {
    // const filtered = _.filter(state.entities, function(item) { return state.entitiesOrder.indexOf(item.id) })
    // console.log(filtered)
    // const visibleEntities = _.filter(state.entities, item => state.entitiesOrder.includes(item.id))
    const visibleEntities = state.entities
    return _.sortBy(visibleEntities, function(item){ return state.entitiesOrder.indexOf(item.id) })
  },
  allUnsorted: (state) => {
    return state.entities;
  }
}

// actions
const actions = {
  ...actionsMixin,
  // loadAll: async ({ commit }, {force = false}) => {
  loadAll: async ({ commit }, { force, page, limit }) => {
    force = force || false
    page = parseInt(page) || 1
    limit = parseInt(limit) || 10
    commit('setLoading', true, { root: true })

    const fetchPolicy = force ? 'network-only' : 'cache-first'
    const response = await apolloClient.query({ query: GET_ALL_TAGS_QUERY, variables: { page: page, limit: limit, direction: 'desc' }, fetchPolicy: fetchPolicy })

    let normalizedData = normalize(response.data, tagsSchema)
    commit('setEntitiesNoOrder', { normalizedData }, { root: true })
    commit('setLoading', false, { root: true })
  },
  loadAllPlusUntagged: async ({ commit }, force = false) => {
    commit('setLoading', true, { root: true })
    const fetchPolicy = force ? 'network-only' : 'cache-first'
    const untaggedResponse = await apolloClient.query({ query: GET_UNTAGGED_QUERY, fetchPolicy: fetchPolicy  })
    const response = await apolloClient.query({ query: GET_ALL_TAGS_NO_PAGE_QUERY, variables: { direction: 'desc' }, fetchPolicy: fetchPolicy })
    response.data.tags.collection.push(untaggedResponse.data.untagged)
    let normalizedData = normalize(response.data, tagsSchema)
    commit('setEntitiesNoOrder', { normalizedData }, { root: true })
    commit('setLoading', false, { root: true })
  },
  loadAllNoPage: async ({ commit }, { force, limit }) => {
    force = (force === undefined) ? false : force
    limit = (limit === undefined) ? 10 : parseInt(limit)
    commit('setLoading', true, { root: true })

    const fetchPolicy = force ? 'network-only' : 'cache-first'
    const response = await apolloClient.query({ query: GET_ALL_TAGS_NO_PAGE_QUERY, variables: { limit: limit, direction: 'desc' }, fetchPolicy: fetchPolicy })

    let normalizedData = normalize(response.data, tagsSchema)
    commit('setEntitiesNoOrder', { normalizedData }, { root: true })
    commit('setLoading', false, { root: true })
  },
  loadById: async ({ commit }, id) => {
    let response = null

    const parsedId = parseInt(id)
    if (typeof(parsedId) == 'number' && parsedId > 0) {
      commit('setLoading', true, { root: true })

      response = await apolloClient.query({ query: GET_TAG_QUERY, variables: { id: parsedId } })
      const normalizedData = normalize(response.data, tagSchema)
      commit('updateEntities', { normalizedData }, { root: true })

      commit('setLoading', false, { root: true })
    }

    return response
  },
  save: async ({ commit }, { id, form }) => {
    let response = null

    commit('setLoading', true, { root: true })
    if (id) {
      response = await apolloClient.mutate({ mutation: UPDATE_TAG_MUTATION, variables: {id: id, tag: form} })
    } else {
      response = await apolloClient.mutate({ mutation: CREATE_TAG_MUTATION, variables: {tag: form} })
      apolloClient.clearStore()
    }

    commit('setLoading', false, { root: true })

    if (response) {
      const normalizedData = normalize(response.data, tagSchema)
      commit('updateEntities', { normalizedData }, { root: true })
    }

    return response
  },

  delete: async ({ commit }, {name, cascadeType}) => {
    commit('setLoading', true, { root: true })

    const response = await apolloClient.mutate({ mutation: DELETE_TAG_MUTATION, variables: { name: name, cascadeType: cascadeType} })
    response.data.tags.map(m => commit('removeEntity', m.id))
    apolloClient.clearStore()

    commit('setLoading', false, { root: true })

    return response
  },
  
  rename: async ({ commit }, {from, to}) => {
    
    let response = null

    commit('setLoading', true, { root: true })
    
    response = await apolloClient.mutate({ mutation: RENAME_TAG_MUTATION, variables: {from: from, to: to} })

    commit('setLoading', false, { root: true })

    if (response) {
      const normalizedData = normalize(response.data, tagSchema)
      commit('updateEntities', { normalizedData }, { root: true })
    }

    return response
  },
}

// mutations
const mutations = {
  ...mutationsMixin
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
